import "./configurationTransforms/configurationTransforms";
import "./configurationVariables/configurationVariables";
import "./customDirectory/customDirectory";
import "./customScripts/customScripts";
import "./iisHome/iisHome";
import "./iisWebSite/iisWebSite";
import "./jsonConfigurationVariables/jsonConfigurationVariables";
import "./substituteInFiles/substituteInFiles";
import "./redgateDatabase/redgateDatabase";
import "./vhd/vhd";
import "./windowsService/windowsService";


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/Features/index.ts